// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__yKbvN","choiceBoxes":"toolbarselects_choiceBoxes__3KJ01","simpleField":"toolbarselects_simpleField__1Mmr5"};